import React from 'react'
import {Field} from "formik";
import {Checkbox} from "components/Form/SpecialButtons";
import Select from "components/Form/Select";

const styles = {
    textField50: {
        display: 'inline-block', width: '50%'
    }
}

const ReponseForm = ({ element, values, errors }) => (

    <div>
        <div style={{width:'100%', display:'flex'}}>
            <div style={{...styles.textField50, paddingRight:10,alignItems:'center'}}>

                {/*<Field*/}
                    {/*customlabel="Automatisée"*/}
                    {/*component={Checkbox}*/}
                    {/*name="autoAnswer"*/}
                    {/*id="autoAnswer"*/}
                    {/*label="autoAnswer"*/}
                {/*/>*/}

                <Field
                    customlabel="Facultative"
                    component={Checkbox}
                    name="optional_response"
                    id="optional_response"
                    label="optionalResponse"
                    style={{marginTop:0}}
                />

            </div>
            <div style={{...styles.textField50, paddingLeft:10}}>

                <Field
                    component={Select}
                    name="method"
                    customlabel="Méthode de saisie"
                    placeholder='Sélectionner une methode'
                    options={ [
                        { value : "text", label: "Texte libre"},
                        { value : "checkbox", label: "Cases à cocher (choix multiples)"},
                        { value : "radio", label: "Bouton radio (choix unique)"},
                        { value : "list_unique", label: "Liste déroulante (choix unique)"},
                        { value : "date", label: "Date"},
                        { value : "datetime", label: "Date et Heure"},
                        { value : "number_type", label: "Numérique"}
                    ]}
                    errors={errors}
                    required
                />




            </div>
        </div>
        {
            (values.method === "checkbox" || values.method === "radio" || values.method === "list_unique") &&
            <div style={{width: '100%', display: 'flex'}}>
                <div style={{...styles.textField50, paddingRight: 10, alignItems: 'center'}}>
                </div>
                <div style={{...styles.textField50, paddingLeft: 10}}>

                    <Field
                        component={Select}
                        name="adding_free_input"
                        customlabel="Ajout d'une saisie libre"
                        placeholder='Sélectionner une valeur'
                        options={[
                            { value: '', label: 'Aucune' },
                            { value: "text", label: "Texte libre" },
                            { value: "date", label: "Date" },
                            { value: "number", label: "Chiffre" },
                            { value : "datetime", label: "Date et Heure" }
                        ]}
                        errors={errors}
                    />

                </div>
            </div>
        }







    </div>


)

export default ReponseForm